import { cartRegister as baseCartRegister } from '@wearejh/m2-pwa-cart-gql/lib/cart.register';

import { userSignedInReaction } from 'src/features/cart/userSignedInReaction.epic';

export function cartRegister() {
    return baseCartRegister({
        userSignedInReaction,
    } as any);
}
